// POST /api/admin/stripe/contractors/tax-info/backfill
export interface StripeTaxInfoBackfillResponse {
  jobId: string;
}

/**
 * Response from GET /api/jobs/{jobId} (JobsController).
 * Represents a Hangfire job, polled to track an enqueued backfill.
 */
export interface JobDetailDto {
  jobId: string;
  jobName: string;
  methodName: string;
  queue: string;
  state: string;
  createdAt: string;
  enqueuedAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
  duration: string | null;
  serverId: string | null;
  exceptionType: string | null;
  exceptionMessage: string | null;
  retryCount: number;
  parameters: Record<string, string>;
}
